var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "886742d8f35125524ee86df94074e50d1d547e64"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "886742d8f35125524ee86df94074e50d1d547e64"
};